import styled from "styled-components";

export const TabelaResultados = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 8px 12px;
    border: 1px solid #dee2e6;
    text-align: left;
  }

  thead {
    background-color: #f8f9fa;
    font-weight: bold;
  }
`;
